import { useContext } from "react";
import { OdysseeContext } from "./context";

const useOdyssee = () => {
	return useContext(OdysseeContext);
};

export default useOdyssee;
